import { emailFundacaoService } from '../services/email-fundacao.service.js'
import { fundacaoService } from '../services/fundacao.service.js'
const { getFundacoesContatos, getTemplatesEmail } = emailFundacaoService()
const { getFiltroFundacao } = fundacaoService()
const { getChoicesActive } = GLOBAL
import SelectMultiple from '../components/SelectMultiple'
import Quill from 'quill'
import FiltroEmail from './FiltroEmail.js'
import {
	assinaturaTemplateEmailFundacao,
	assinaturaTemplateEmailIsmael,
	assinaturaTemplateEmailMatheus,
} from '../constants/email.js'

export default {
	props: ['emailEnviadoSelecionado'],
	emits: ['fechar-modal-envio'],
	components: {
		SelectMultiple,
		FiltroEmail,
	},
	data() {
		return {
			modelFiltros: {
				fundo: [],
				tag: [],
				tempoSenAtendimentoRapido: null,
			},
			readonlyMode: false,
			btnFiltro: null,
			dialogFiltros: false,
			quill: null,
			corpo_email: '',
			fundacoesList: [],
			templates: [],
			templateSelecionado: '',
			assunto: '',
			filtros: {
				fundo: [],
				tag: [],
				tempoSenAtendimentoRapido: null,
			},
			fundoOption: [],
			tagOption: [],
			tempoSenAtendimentoRapidoOption: [
				{ label: '1 a 3 meses', value: '1,3' },
				{ label: '4 a 6 meses', value: '4,6' },
				{ label: 'Mais de 6 meses', value: '6,1000' },
			],

			loading: {
				enviarEmail: false,
			},
		}
	},
	watch: {
		emailEnviadoSelecionado(newVal) {
			if (newVal) {
				// Preenche selects e inputs
				this.assunto = newVal.assunto
				this.templateSelecionado = newVal.template_id?.toString() || ''
				this.$nextTick(() => {
					// Fundacao
					const selectFundacoes = getChoicesActive(
						'email_fundacao',
						window.listOfChoices
					)
					selectFundacoes?.setChoiceByValue([newVal.envinhado_para_id])
					// Template
					const selectModelos = getChoicesActive(
						'email_modelo',
						window.listOfChoices
					)
					selectModelos?.setChoiceByValue(newVal.template_id)
					// Corpo do email
					if (this.quill) {
						this.setDeltaToQuillByContent(newVal.corpo_alterado || newVal.corpo)
						this.quill.enable(false)
					}
					// Desabilita selects e input
					selectFundacoes?.disable()
					selectModelos?.disable()
				})
				this.readonlyMode = true
			} else {
				// Habilita edição novamente
				this.readonlyMode = false
				this.$nextTick(() => {
					const selectFundacoes = getChoicesActive(
						'email_fundacao',
						window.listOfChoices
					)
					const selectModelos = getChoicesActive(
						'email_modelo',
						window.listOfChoices
					)
					selectFundacoes?.enable()
					selectModelos?.enable()
					if (this.quill) this.quill.enable(true)
				})
			}
		},

		templateSelecionado() {
			const template = this.templates.find(
				(t) => t.id_template === parseInt(this.templateSelecionado)
			)
			if (template) {
				this.assunto = template.assunto
				this.$nextTick(() => {
					if (this.quill) {
						this.setDeltaToQuillByContent(template.corpo)
					}
				})
			} else {
				this.assunto = ''
				this.$nextTick(() => {
					if (this.quill) {
						this.clearEditor()
					}
				})
			}
		},
	},
	computed: {
		tituloHeaderModal() {
			return this.readonlyMode ? 'E-mail Cliente' : 'Criar novo E-mail'
		},
	},
	methods: {
		abrirMenuFiltros() {
			this.$nextTick(() => {
				this.menuOpen = true
				if (this.$refs.btnFiltro) {
					console.warn('Ref do botão Filtros está perdido!')
				}
			})
		},
		fecharMenuFiltros() {
			this.menuOpen = false
		},
		async initSelectFiltros() {
			const listaFiltroFundacao = await getFiltroFundacao()
			this.fundoOption = listaFiltroFundacao?.fundos?.map((item) => ({
				value: item[1],
				label: item[1],
			}))
			this.tagOption = listaFiltroFundacao?.tags?.map((item) => ({
				value: item[0],
				label: item[1],
			}))
			// Popula Choices.js dos filtros se necessário
		},
		async getFundacoesFiltroQuery(campo) {
			const paramsUrl = new URLSearchParams()
			if (campo !== 'tempo' && campo !== 'all' && this.filtros[campo]) {
				paramsUrl.append(
					campo,
					this.filtros[campo].map((itemFiltro) => itemFiltro.value).join(',')
				)
			}
			if (this.filtros.tempoSenAtendimentoRapido) {
				paramsUrl.append(
					'meses_sem_atendimento',
					this.filtros.tempoSenAtendimentoRapido
				)
			}
			const queryFiltroFundacao =
				paramsUrl.size > 0 ? `?${paramsUrl.toString()}` : ''
			return await getFundacoesContatos(queryFiltroFundacao)
		},
		async getInfoFundacoesFiltro() {
			let responseFundacoesFundo = []
			let responseFundacoesTag = []
			let responseFundacoesTempo = []
			let fundacoesUnificado = []

			if (this.filtros.fundo && this.filtros.fundo.length > 0) {
				responseFundacoesFundo = await this.getFundacoesFiltroQuery('fundo')
			}
			if (this.filtros.tag && this.filtros.tag.length > 0) {
				responseFundacoesTag = await this.getFundacoesFiltroQuery('tag')
			}
			if (this.filtros.tempoSenAtendimentoRapido) {
				responseFundacoesTempo = await this.getFundacoesFiltroQuery('tempo')
			}

			const temFiltroFundo = this.filtros.fundo && this.filtros.fundo.length > 0
			const temFiltroTag = this.filtros.tag && this.filtros.tag.length > 0
			const temFiltroTempo = this.filtros.tempoSenAtendimentoRapido

			if (!temFiltroFundo && !temFiltroTag && !temFiltroTempo) {
				fundacoesUnificado = await this.getFundacoesFiltroQuery('all')
			} else {
				let resultadosCombinados = []
				if (temFiltroFundo)
					resultadosCombinados = resultadosCombinados.concat(
						responseFundacoesFundo
					)
				if (temFiltroTag)
					resultadosCombinados =
						resultadosCombinados.concat(responseFundacoesTag)
				if (temFiltroTempo)
					resultadosCombinados = resultadosCombinados.concat(
						responseFundacoesTempo
					)
				fundacoesUnificado = resultadosCombinados
			}
			this.fundacoesList = fundacoesUnificado
			this.initSelectFundacoes()
		},
		initSelectFundacoes() {
			const opcoes = this.fundacoesList?.map((f) => ({
				value: f.id_fundacao,
				label: f.sigla_fundacao,
			}))
			const selectFundacoes = getChoicesActive(
				'email_fundacao',
				window.listOfChoices
			)
			selectFundacoes?.clearChoices()
			selectFundacoes?.setChoices([{ value: '', label: 'Selecione' }, ...opcoes])
		},
		initSelectModelos() {
			const opcoes = this.templates?.map((t) => ({
				value: t.id_template,
				label: t.assunto,
			}))
			const selectModelos = getChoicesActive(
				'email_modelo',
				window.listOfChoices
			)
			selectModelos?.clearChoices()
			selectModelos?.setChoices([{ value: '', label: 'Selecione' }, ...opcoes])

			// Adiciona evento para atualizar templateSelecionado ao mudar o select
			const selectElement = selectModelos.passedElement.element
			selectElement.removeEventListener('change', this.handleModeloChange)
			selectElement.addEventListener('change', this.handleModeloChange)
		},
		handleModeloChange(e) {
			this.templateSelecionado = e.target.value
		},
		initQuillEditor() {
			this.quill = new Quill(this.$refs.editor, {
				theme: 'snow',
				modules: {
					toolbar: [
						[{ header: [1, 2, false] }],
						['bold', 'italic', 'underline'],
						[{ list: 'ordered' }, { list: 'bullet' }],
						[{ color: [] }, { background: [] }],
						['clean', 'image'],
					],
				},
			})
			this.quill.on('text-change', () => {
				this.corpo_email = this.quill.root.innerHTML
			})
		},
		setDeltaToQuillByContent(content) {
			// Limpa o editor antes de inserir novo conteúdo
			this.quill.setText('', 'silent')
			this.$nextTick(() => {
				// Insere o HTML diretamente no editor
				this.quill.root.innerHTML = content || ''
				// Atualiza o corpo_email para manter sincronizado
				this.corpo_email = this.quill.root.innerHTML
			})
		},
		clearEditor() {
			this.quill.setText('', 'silent')
			this.$nextTick(() => {
				this.quill.root.innerHTML = ''
				this.corpo_email = ''
			})
		},

		async aplicarFiltrosFundacao(filtros) {
			const paramsUrl = new URLSearchParams()
			if (filtros.fundo && filtros.fundo.length > 0) {
				paramsUrl.append(
					'fundo',
					filtros.fundo.map((item) => item.value).join(',')
				)
			}
			if (filtros.tag && filtros.tag.length > 0) {
				paramsUrl.append('tag', filtros.tag.map((item) => item.value).join(','))
			}
			if (filtros.tempoSenAtendimentoRapido) {
				paramsUrl.append(
					'meses_sem_atendimento',
					filtros.tempoSenAtendimentoRapido
				)
			}
			const query = paramsUrl.size > 0 ? `?${paramsUrl.toString()}` : ''
			// Busca as fundações filtradas
			this.fundacoesList = await getFundacoesContatos(query)
			this.initSelectFundacoes()
			this.limparCamposEnvioEmail()
		},
		async limparFiltrosEmail() {
			this.modelFiltros = {
				fundo: [],
				tag: [],
				tempoSenAtendimentoRapido: null,
			}

			this.limparCamposEnvioEmail()
			this.fundacoesList = await getFundacoesContatos()
			this.initSelectFundacoes()
		},

		limparCamposEnvioEmail() {
			// Limpa selects
			const selectFundacoes = getChoicesActive(
				'email_fundacao',
				window.listOfChoices
			)
			const selectModelos = getChoicesActive(
				'email_modelo',
				window.listOfChoices
			)
			selectFundacoes?.removeActiveItems()
			selectModelos?.removeActiveItems()
			// Limpa inputs
			this.assunto = ''
			this.templateSelecionado = ''
			// Limpa editor
			this.clearEditor()
		},

		filtrarFundacoesValid() {
			const selectFundacoes = getChoicesActive(
				'email_fundacao',
				window.listOfChoices
			)
			return selectFundacoes
				.getValue(true)
				.filter((id) => id !== '')
				.map(Number)
		},

		fecharModalEmailEnvio() {
			modal_padrao_vue.closeModal('email_envio_template')
			this.limparFiltrosEmail()
			this.readonlyMode = false
			this.$emit('fechar-modal-envio')
		},

		async enviarEmailFundacao() {
			this.loading.enviarEmail = true

			const fundacoesFiltrado = this.filtrarFundacoesValid()
			let assinatura = ''
			const usuarioAtual = GLOBAL.usuario.nome

			if (usuarioAtual.toLowerCase() === 'ismael') {
				assinatura = assinaturaTemplateEmailIsmael
			} else if (usuarioAtual.toLowerCase() === 'matheus') {
				assinatura = assinaturaTemplateEmailMatheus
			} else {
				assinatura = assinaturaTemplateEmailFundacao
			}

			const corpoFinal = this.corpo_email + '<br/>' + assinatura

			const data = {
				template_id: this.templateSelecionado,
				clientes_ids: fundacoesFiltrado,
				assunto: this.assunto,
				corpo: corpoFinal,
			}

			if (!fundacoesFiltrado.length || !this.assunto || !this.corpo_email) {
				GLOBAL.showToastify('⚠️ Preencha todos os campos obrigatórios.')
				return
			}

			try {
				await emailFundacaoService().sendEmail(data)
				GLOBAL.showToastify('✅ Email enviado com sucesso.')
				this.limparCamposEnvioEmail()

				window.location.reload()
				// Se necessário, atualize a tabela de emails aqui
			} catch (err) {
				GLOBAL.showToastify('❌ Erro ao enviar email.')
			} finally {
				this.loading.enviarEmail = false
			}
		},
	},

	async mounted() {
		this.initQuillEditor()
		this.fundacoesList = await getFundacoesContatos()
		this.templates = (await getTemplatesEmail())?.results || []
		await this.initSelectFiltros()
		this.initSelectFundacoes()
		this.initSelectModelos()
	},

	template: `
         <section
            class="modal--content rounded-md flex-1 w-full !h-max overflow-[initial] relative"
            data-id="email_envio_template">
            <div class="w-full">
                <div
                    class="flex flex-col gap-32 mb-16 md2:mb-0 !mx-auto">
					<header class="flex items-center justify-between w-full px-24 pt-24 pb-16 bg-primary-pure">
						 <h2 class="text-lg font-medium text-white">{{ tituloHeaderModal }}</h2>
						<button 
							type="button" 
							class="w-32 h-32 transition-transform rounded-full cursor-pointer hover:scale-125 bg-white/10 close-btn"
							@click="fecharModalEmailEnvio">
							<svg class="w-32 h-32">
								<use xlink:href="#icon_close"></use>
							</svg>
						</button>
					</header>

                    <div class="flex items-center gap-8 px-24">
						<q-btn 
							v-if="!readonlyMode"
							label="Filtros" 
							color="primary" 
							icon="filter_alt" 
							class="btn !h-48 ml-auto !px-8 py-4">
							<q-menu
								:anchor="anchor"
								:self="self"
								:offset="[0, 10]"
								transition-show="jump-down"
								transition-hide="jump-up"
							>
								<div class="min-w-[300px] max-w-[400px]">

									<filtro-email 
										:model-value="modelFiltros"
										@update:modelValue="modelFiltros = $event"
										@aplicar-filtros="aplicarFiltrosFundacao(modelFiltros)"
										@limpar-filtros="limparFiltrosEmail()"
									>
									</filtro-email>

								</div>
							</q-menu>
						</q-btn>
                    </div>
                    <div class="w-full max-h-[600px] overflow-y-scroll px-24">
                        <form @submit.prevent="enviarEmailFundacao" class="flex gap-16 flex-col">
                            <div class="flex flex-col">
                                <label class="font-semibold label">Fundações</label>
                                <div class="h-48 select-container select-multiplo">
                                    <select
                                        js-choices
                                        name="email_fundacao"
                                        id="email_fundacao"
                                        multiple
                                        js-choices-props='{ "searchEnabled": true, "searchChoices": true,  "removeItems": true, "removeItemButton": true}'></select>
                                </div>
                            </div>

                            <div class="flex flex-col">
                                <label class="font-semibold label">Modelo</label>
                                <div class="h-48 select-container">
                                    <select
                                        js-choices
                                        name="email_modelo"
                                        id="email_modelo"
                                        js-choices-props='{ "searchEnabled": true, "searchChoices": true,  "removeItems": true, "removeItemButton": true}'></select>
                                </div>
                            </div>
                            <div class="flex flex-col">
                                <label class="font-semibold label">Assunto</label>
                                <input
                                    v-model="assunto"
                                    name="email_assunto"
                                    class="h-48 input-text"
                                    js-ativo
                                    type="text"
                                    required
									:readonly="readonlyMode" />
                            </div>
                            <div class="flex flex-col">
                                <label class="font-semibold label">Corpo do e-mail</label>
                                <div ref="editor"></div>
                            </div>
                            <div v-if="!readonlyMode" class="w-full flex justify-end items-center">
                                <button v-if="false" class="h-48 btn" type="submit">Enviar email</button>
                                <q-btn  :loading="loading.enviarEmail" class="h-48 btn" type="submit">Enviar email</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

			
			
        </section>
    `,
}
